import React from "react";

// Pantalla final del pago en linea: antes solo era un titulo sin salida. Ahora dice que paso, que hacer y
// ofrece botones para seguir (volver al inicio, intentar de nuevo).
//   tipo: "aprobado" | "rechazado" | "reintentar" | "advertencia"

const dosDigitos = (n) => String(n).padStart(2, "0");
const fechaHora = (f) => `${dosDigitos(f.getDate())}/${dosDigitos(f.getMonth() + 1)}/${f.getFullYear()} ${dosDigitos(f.getHours())}:${dosDigitos(f.getMinutes())}`;
export const dinero = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const TITULOS = {
  aprobado: { icono: "✅", titulo: "Pago exitoso" },
  rechazado: { icono: "❌", titulo: "El pago no fue aprobado" },
  reintentar: { icono: "⚠️", titulo: "No se pudo completar el pago" },
  advertencia: { icono: "⚠️", titulo: "Importante" },
};

const ResultadoPago = ({ resultado, onReintentar, onInicio }) => {
  const { tipo, mensaje, autorizacion, importe, conceptos = [], fecha } = resultado;
  const t = TITULOS[tipo] || TITULOS.advertencia;
  const puedeReintentar = tipo === "rechazado" || tipo === "reintentar";

  return (
    <div className={`ResultadoPago ResultadoPago--${tipo}`} role="status">
      <div className="ResultadoPago-icono" aria-hidden="true">{t.icono}</div>
      <h2 className="ResultadoPago-titulo">{t.titulo}</h2>

      {tipo === "aprobado" ? (
        <>
          <p className="ResultadoPago-mensaje">Banorte aprobó tu pago.</p>
          <dl className="ResultadoPago-datos">
            <dt>Total</dt><dd>{dinero(importe)}</dd>
            {autorizacion && (<><dt>Autorización</dt><dd>{autorizacion}</dd></>)}
            {fecha && (<><dt>Fecha</dt><dd>{fechaHora(fecha)}</dd></>)}
            {conceptos.length > 0 && (<><dt>Conceptos</dt><dd>{conceptos.map((c) => c.concepto).join(", ")}</dd></>)}
          </dl>
          <p className="ResultadoPago-nota">
            Guarda una captura de esta pantalla o el comprobante que te muestra Banorte. Si necesitas aclarar algo
            en tu plantel, da el número de autorización.
          </p>
        </>
      ) : (
        <p className="ResultadoPago-mensaje">{mensaje}</p>
      )}

      <div className="ResultadoPago-botones">
        {puedeReintentar && (
          <button type="button" className="ResultadoPago-boton ResultadoPago-boton--principal" onClick={onReintentar}>
            Intentar de nuevo
          </button>
        )}
        <button type="button" className={`ResultadoPago-boton${puedeReintentar ? "" : " ResultadoPago-boton--principal"}`} onClick={onInicio}>
          Volver al inicio
        </button>
      </div>
    </div>
  );
};

export default ResultadoPago;
